import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

import { tagPreviewPackagesKeys } from './query-key-factory';

import type { RuleGroup } from 'src/app/components/lib/query-builder/use-query-builder';

const GET_SMART_TAG_PACKAGES_PREVIEW_ENDPOINT = 'api/smart-tags/preview-smart-tag-packages';

type PreviewSmartTagPackagesQueryParams = {
  Id: number | null;
  IsEnabled: boolean;
  RuleGroup: RuleGroup;
};

export type SmartTagPackagePreview = {
  PackageId: number;
  ProductBrand: string;
  ProductCategory: string;
  ProductName: string;
  SerialNumber: string;
};

export const usePreviewSmartTagPackagesQuery = (request: PreviewSmartTagPackagesQueryParams) => {
  const { Id, IsEnabled, RuleGroup } = request;
  return useQuery({
    queryKey: [...tagPreviewPackagesKeys.one(Id), { RuleGroup }],
    queryFn: () => fetchData<SmartTagPackagePreview[]>(GET_SMART_TAG_PACKAGES_PREVIEW_ENDPOINT, { Id, RuleGroup }),
    enabled: IsEnabled,
  });
};
